interface MetaProps {
  threadKey?: string;
  turn?: number;
  verbosity?: string;
  durationSeconds?: number;
}

export function Meta({ threadKey, turn, verbosity, durationSeconds }: MetaProps) {
  const parts: string[] = [];
  if (threadKey) {
    let s = `thread: ${threadKey}`;
    if (turn) s += ` · turn ${turn}`;
    if (verbosity) s += ` · ${verbosity.toLowerCase()}`;
    parts.push(s);
  }
  if (typeof durationSeconds === 'number' && isFinite(durationSeconds)) {
    parts.push(`${durationSeconds.toFixed(1)}s`);
  }
  if (parts.length === 0) return null;
  return <div className="text-xs text-text-muted mt-2">{parts.join(' · ')}</div>;
}
